import { createSlice } from "@reduxjs/toolkit";

const chatData = createSlice({
  name: "chatData",
  initialState: {
    newChat: false,
    currentUserMessages: [],
    currentUserDate: "",
    checkDelete: false,
    sortChat: false,
    newChatMembers: false,
    oldChats: 0,
    hasNewChat: false,
    renderChats: false,
    unreadMessagesCount: {},
    deleteChat: false,
    unreadChatNotifications: {}
  },
  reducers: {
    updateNewChat: (state, action) => {
      state.newChat = action.payload;
    },
    handleCurrentUserDate: (state, action) => {
      if (action.payload == 0 || action.payload == 1) {
        state.currentUserDate = "";
      } else {
        state.currentUserDate = action.payload;
      }
    },
    handleCurrentUserMessages: (state, action) => {
      state.currentUserMessages = action.payload;
    },
    updateDelteFunc: (state, action) => {
      state.checkDelete = action.payload;
    },
    updateSortChat: (state, action) => {
      state.sortChat = action.payload;
    },
    updateChatMembers: (state, action) => { 
      state.newChatMembers = action.payload;
    },
    updateChatCount: (state, action) => {
      const newTotal = action.payload;
      state.hasNewChat = newTotal > state.oldChats;
      state.oldChats = newTotal;
    },
    clearNotification: (state) => {
      state.hasNewChat = false;
    },
    updateRenderChats: (state, action) => {
      state.renderChats = action.payload;
    },
    setUnreadMessagesCount(state, action) {
      const { chatId, count } = action.payload;
      state.unreadMessagesCount[chatId] = count;

      let cnt = 0
      Object.values(state.unreadMessagesCount)?.forEach((msgCount) => {
        if (msgCount > 0) {
          cnt += 1
        }
      })

      state.groupUnreadMessages = cnt
      localStorage.setItem('unreadMessagesCount', JSON.stringify(state.groupUnreadMessages));
    },
    updateDeleteChat: (state, action) => {
      state.deleteChat = action.payload;
    },
    handleUnreadChatNotifications: (state, action) => { 
      state.unreadChatNotifications = action.payload;
    }
  },
});

export const {
  updateNewChat,
  handleCurrentUserMessages,
  handleCurrentUserDate,
  updateDelteFunc,
  updateSortChat,
  updateChatMembers,
  updateChatCount,
  clearNotification,
  updateRenderChats,
  setUnreadMessagesCount,
  updateDeleteChat,
  handleUnreadChatNotifications
} = chatData.actions;

export default chatData.reducer;
